import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import Button from '@mui/material/Button';

import ReportService from '../../api/services/ReportService';

import LoadingIndicator from '../../components/loading-indicator/loading';

function CustomerNotifies() {
    const [isProcessing, setIsProcessing] = useState(false);
    const [downloadInitiated, setDownloadInitiated] = useState(false);

    function onSubmitDownload(event) {
        event.preventDefault();

        setIsProcessing(true);
        setDownloadInitiated(true);

        toast.success("Successfully kicked off report. You will be emailed when it has completed.");

        ReportService.downloadCustomerNotifiesReport().then(() => {
            setIsProcessing(false);
        }).catch((error) => {
            setIsProcessing(false);
            setDownloadInitiated(false);
            toast.error('Download failed: ' + error);
        });
    }
    return (
        <div>
            <section className="dashboard card">                
                <article>
                    <h1>Customer Notifies Report</h1>

                    <p>Click Submit to initiate the report generation.</p>

                    <Button type="submit" variant="contained" color="primary" onClick={onSubmitDownload} disabled={downloadInitiated}>
                        Submit
                    </Button>
                    
                    <LoadingIndicator visible={isProcessing} />
                </article>
            </section>
        </div>
    )
}

CustomerNotifies.propTypes = {
}

function mapStateToProps(state) {
    return {}
}

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerNotifies);